module.exports = __webpack_public_path__ + "static/media/blog-47.86272818.webp";